<template lang="pug">
v-container#package-tables(fluid, tag="div")
  h3 Package List
  //- v-btn.mb-3(v-if="$store.getters.isParent" color="#03B3EB", @click="goto") Purchase Package
  v-card
    v-card-title
      v-text-field.my-2(
        v-model="search",
        append-icon="mdi-magnify",
        label="Search",
        single-line,
        hide-details
      )
    v-data-table(
      :headers="package_headers",
      :items="package_list",
      :search="search"
      single-expand
      :expanded.sync="expanded"
      item-key="id"
      show-expand
    )
      template(v-slot:expanded-item="{ headers, item }")
        td(:colspan="headers.length")
          PackageService(:packageId="selectedPackageId")
      template(v-slot:item.type="{ item }")
        td {{ item.type == "1" ? 'Individual' : item.type == "2" ? 'Corporate' : 'N/A' }}
      template(v-slot:item.status="{ item }")
        td {{ parseInt(item.status) ? 'ACTIVE' : 'SUSPENDED' }}
      template(v-slot:item.created_at="{ item }")
        td {{ $moment(parseInt(item.created_at*1000)).format('DD MMM YYYY hh:mm a') }}
      template(v-slot:item.updated_at="{ item }")
        td {{ $moment(parseInt(item.updated_at*1000)).format('DD MMM YYYY hh:mm a') }}
      template(v-slot:item.actions="{ item }")
        td.d-flex.flex-row
          v-icon.mr-2(:disabled="!$store.getters.isParent" small, color="#03B3EB", @click="topup(item)") mdi-cart-arrow-up
  v-dialog(data-app, v-model="dialog", persistent, max-width="600px")
    v-card
      v-card-title
        span.headline Top Up Package
      v-card-text
        v-form.p-4(ref="edit", v-model="valid", lazy-validation)
          v-text-field.mb-2(
            readonly,
            disabled,
            v-model="editedItem.package_id",
            label="Package ID",
            required
          )
          v-text-field.mb-2(
            readonly,
            disabled,
            v-model="editedItem.package_name",
            label="Package Name",
            required
          )
          v-text-field.mb-2(
            type="number",
            v-model="topupBalance",
            :rules="numberRules",
            label="Top Up Balance",
            required
          )
      v-card-actions
        v-spacer
        v-btn(color="blue darken-1", text, @click="close") Cancel
        v-btn(color="blue darken-1", text, @click="save") Top Up
</template>

<script>
import PackageService from "@/views/portal/user/PackageService"

export default {
  components: {
    PackageService
  },
  name: "Package",
  data() {
    return {
      expanded: [],
      search: "",
      dialog: false,
      editedIndex: -1,
      editedItem: {},
      package_list: [],
      package_headers: [
        { text: "Actions", value: "actions" },
        { text: "#", value: "id", cellClass: "font-weight-bold" },
        { text: "Package ID", value: "package_id", cellClass: "font-weight-bold" },
        { text: "Name", value: "package_name" },
        { text: "Balance", value: "available_balance" },
        { text: "Description", value: "description" },
        { text: "Start Date", value: "start_date" },
        { text: "End Date", value: "end_date" },
        { text: "C.Dt", value: "created_at" },
        { text: "M.Dt", value: "updated_at" },
      ],
      topupBalance: 0,
      numberRules: [
        (v) => !!v || "Required",
        (v) => parseFloat(v) > 0 || "Cannot be negative",
      ],
      valid: true,
      loading: false,
    };
  },
  computed: {
    selectedPackageId() {
      return this.expanded.length ? this.expanded[0].package_id : ""
    }
  },
  mounted() {
    this.getPackageList();
  },
  methods: {
    goto(item) {
      this.$router.push("/portal/user/purchase");
    },
    reset() {
      this.$refs.form.reset();
    },
    topup(item) {
      this.editedIndex = this.package_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    save() {
      if (!this.$refs.edit.validate()) return;

      const url = "https://saas-api.xendity.com/v1/user/topup-balance";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
        package_id: this.editedItem.package_id,
        topup_balance: this.topupBalance
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function (response) {
          // Success
          try {
            if (response) {
              this.loading = false;
              if (response.body.success == false)
                this.$swal(
                  "Top up package balance error",
                  response.body.data.message,
                  "error"
                );
              else {
                this.$swal("Top up package balance successful!", "Success", "success");
                this.close();
                this.getPackageList();
              }
            }
          } catch (error) {
            this.$swal(
              "Top up package balance error",
              response.body.data.message,
              "error"
            );
          }
        })
        .catch((response) => {
          this.$swal(
            "Top up package balance error",
            response.body.data.message,
            "error"
          );
        });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
    getPackageList() {
      const url = "https://saas-api.xendity.com/v1/user/get-package";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then((response) => {
          // Success
          try {
            if (response) {
              if (response.body.success == false)
                this.$swal(
                  "Get user package list failed",
                  response.body.data.message,
                  "error"
                );
              else this.package_list = response.body.data.package_list;
            }
          } catch (error) {
            this.$swal(
              "Get user package list failed",
              response.body.data.message,
              "error"
            );
          }
        })
        .catch((response) => {
          this.$swal(
            "Get user package list failed",
            response.body.data.message,
            "error"
          );
        });
    },
  },
};
</script>